import {useEffect,useRef,useState} from 'react';
import {useLocation} from 'react-router-dom';
import http from '../services/http';
import './SmsConsentPage.css';
export default function EmailUnsubscribePage(){
  const {hash}=useLocation();
  return <EmailUnsubscribeContent key={hash}/>;
}
function EmailUnsubscribeContent(){
  const {hash}=useLocation();
  const [token]=useState(()=>new window.URLSearchParams(hash.slice(1)).get('token'));
  const [busy,setBusy]=useState(false),[done,setDone]=useState(false),[error,setError]=useState('');
  const lock=useRef(false),alive=useRef(true);
  const valid=typeof token==='string'&&/^[a-f0-9]{64}$/.test(token);
  useEffect(()=>{
    alive.current=true;
    const meta=document.createElement('meta');meta.name='referrer';meta.content='no-referrer';document.head.append(meta);
    return()=>{alive.current=false;meta.remove();};
  },[]);
  async function unsubscribe(){
    if(lock.current||!valid)return;
    lock.current=true;setBusy(true);setError('');
    try{
      await http.post('/public/email-consent/unsubscribe',{token},{withCredentials:false});
      if(alive.current){setDone(true);window.history.replaceState(null,'',window.location.pathname);}
    }catch(e){if(alive.current)setError(e.response?.status===404?'This unsubscribe link is invalid. Please use the link in your email.':'We could not confirm your unsubscribe. Please try again.');}
    finally{lock.current=false;if(alive.current)setBusy(false);}
  }
  return <main className="sms-capture"><section className="sms-capture-card" aria-labelledby="email-preferences-title"><header><div className="sms-capture-mark" aria-hidden="true">m</div><p className="sms-capture-eyebrow">Email preferences</p><h1 id="email-preferences-title">{done?'You’re unsubscribed':'Unsubscribe from emails'}</h1></header>
    {done?<div className="sms-capture-success" role="status"><p>You will no longer receive this organization’s workflow emails at this address.</p><p>You can close this page.</p></div>:valid?<><p>Stop receiving workflow emails from the organization that sent you this link?</p><p>Your SMS preferences will stay the same.</p>{error&&<p className="sms-capture-error" role="alert">{error}</p>}<button disabled={busy} onClick={unsubscribe}>{busy?'Saving your preference…':'Unsubscribe'}</button></>:<p role="alert" className="sms-capture-error">This link is invalid or missing. Please use the unsubscribe link in your email.</p>}
    <footer>Milton · Your communication preferences</footer>
  </section></main>;
}
